// CROSSSELL-109 — manual UA/EN title overrides (top visible SKUs).
export type TitleOverride = { ua?: string; en?: string; note?: string };
export const PRODUCT_TITLE_OVERRIDES: Record<string, TitleOverride> = {
  "3123026750": {
    "ua": "Кокосове молоко 17–19% M&K",
    "en": "M&K Coconut Milk 17–19%",
    "note": "manual_override"
  },
  "3123220591": {
    "ua": "Соус Теріякі Вок з обсмаженим кунжутом",
    "en": "Teriyaki Wok Sauce with Toasted Sesame",
    "note": "manual_override"
  },
  "3123227401": {
    "ua": "Кокосове молоко низькокалорійне Chef's Choice Premium Lite",
    "en": "Chef's Choice Premium Lite Coconut Milk",
    "note": "manual_override"
  },
  "3123245301": {
    "ua": "Локшина Koka зі смаком масали швидкого приготування",
    "en": "Koka Instant Noodles Masala Flavour",
    "note": "manual_override"
  },
  "3123246531": {
    "ua": "Локшина Koka зі смаком том яму швидкого приготування",
    "en": "Koka Instant Noodles Tom Yum Flavour",
    "note": "manual_override"
  },
  "3123247157": {
    "ua": "Локшина Lucky Me! філіппінська лимон-чилі швидкого приготування",
    "en": "Lucky Me! Pancit Canton Chilimansi",
    "note": "manual_override"
  },
  "3123248038": {
    "ua": "Локшина Lucky Me! зі смаком курки швидкого приготування",
    "en": "Lucky Me! Instant Noodle Soup Chicken Flavour",
    "note": "manual_override"
  },
  "3123248577": {
    "ua": "Кокосове молоко Ranre Organic 17%",
    "en": "Ranre Organic Coconut Milk 17%",
    "note": "manual_override"
  },
  "3123256873": {
    "ua": "Чіпси Lay's зі смаком італійського червоного м'яса",
    "en": "Lay's Potato Chips Italian Red Meat",
    "note": "manual_override"
  },
  "3123257565": {
    "ua": "Чіпси Lay's зі смаком мексиканської курки та томатів",
    "en": "Lay's Potato Chips Mexican Chicken & Tomato",
    "note": "manual_override"
  },
  "3123262871": {
    "ua": "Паста Belazu Black Olive Tapenade",
    "en": "Belazu Black Olive Tapenade",
    "note": "manual_override"
  },
  "3123263483": {
    "ua": "Паста Belazu Rose Harissa",
    "en": "Belazu Rose Harissa Paste",
    "note": "manual_override"
  },
  "3123265624": {
    "ua": "Соус Belazu тахіні",
    "en": "Belazu Tahini / Tagine Paste",
    "note": "manual_override"
  },
  "3123344710": {
    "ua": "Рис для суші органічний Clearspring",
    "en": "Clearspring Organic Sushi Rice",
    "note": "manual_override"
  },
  "3123347019": {
    "ua": "Локшина удон широка органічна Clearspring",
    "en": "Clearspring Organic Wide Udon Noodles",
    "note": "manual_override"
  },
  "3123350935": {
    "ua": "Локшина удон органічна Clearspring",
    "en": "Clearspring Organic Japanese Udon Noodles",
    "note": "manual_override"
  },
  "3123351454": {
    "ua": "Суміш олій з чорного кмину та кокоса з медом органічна",
    "en": "Organic Black Cumin Coconut Oil with Honey",
    "note": "manual_override"
  }
} as const;
